import { render, staticRenderFns } from "./FrontGrossAccrualInventoryCosts.vue?vue&type=template&id=a2106626&scoped=true"
import script from "./FrontGrossAccrualInventoryCosts.vue?vue&type=script&lang=js"
export * from "./FrontGrossAccrualInventoryCosts.vue?vue&type=script&lang=js"
import "./FrontGrossAccrualInventoryCosts.vue?vue&type=style&index=0&id=a2106626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2106626",
  null
  
)

export default component.exports